import { ReactNode } from "react";

import { Language } from "../../../../../../../../../services";
import tPath from "../../../constants/tPath";

import title from "./title";
import contactPersonName from "./contactPersonName";
import contactPersonPhone from "./contactPersonPhone";
import balance from "./balance";
import bonusBalance from "./bonusBalance";
import mobileApp from "./mobileApp";
import cabinet from "./cabinet";
import company from "./company";
import taxiService from "./taxiService";
import status from "./status";
import group from "./group";

const translationTablePath = `${tPath}.columns`;

export enum ColumnId {
	Title = "title",
	ContactPersonName = "contactPersonName",
	ContactPersonPhone = "contactPersonPhone",
	Balance = "balance",
	BonusBalance = "bonusBalance",
	MobileApp = "mobileApp",
	Cabinet = "cabinet",
	Company = "company",
	TaxiService = "taxiService",
	Status = "status",
	Group = "group",
}

export interface Column {
	render: (options: Column.Options) => ReactNode;
	label: string | string[];
}

export declare namespace Column {
	interface Options {
		width?: number;
		language: Language;
		onResize?: (width: number, columnId: ColumnId) => void;
	}
}

export const columns: Record<ColumnId, Column> = {
	[ColumnId.Title]: {
		render: title,
		label: [`${translationTablePath}.title`, "Title"],
	},
	[ColumnId.ContactPersonName]: {
		render: contactPersonName,
		label: [
			`${translationTablePath}.contactPersonName`,
			"Contact Person Name",
		],
	},
	[ColumnId.ContactPersonPhone]: {
		render: contactPersonPhone,
		label: [
			`${translationTablePath}.contactPersonPhone`,
			"Contact Person Phone",
		],
	},
	[ColumnId.Balance]: {
		render: balance,
		label: [`${translationTablePath}.balance`, "Balance"],
	},
	[ColumnId.BonusBalance]: {
		render: bonusBalance,
		label: [`${translationTablePath}.bonusBalance`, "Bonus Balance"],
	},
	[ColumnId.MobileApp]: {
		render: mobileApp,
		label: [`${translationTablePath}.mobileApp`, "Mobile App"],
	},
	[ColumnId.Cabinet]: {
		render: cabinet,
		label: [`${translationTablePath}.cabinet`, "Cabinet"],
	},
	[ColumnId.Company]: {
		render: company,
		label: [`${translationTablePath}.company`, "Company"],
	},
	[ColumnId.TaxiService]: {
		render: taxiService,
		label: [`${translationTablePath}.taxiService`, "Taxi Service"],
	},
	[ColumnId.Status]: {
		render: status,
		label: [`${translationTablePath}.status`, "Status"],
	},
	[ColumnId.Group]: {
		render: group,
		label: [`${translationTablePath}.group`, "Group"],
	},
};

export const defaultColumnIds = [
	ColumnId.Title,
	ColumnId.ContactPersonName,
	ColumnId.ContactPersonPhone,
	ColumnId.Balance,
	ColumnId.BonusBalance,
	ColumnId.MobileApp,
	ColumnId.Cabinet,
	ColumnId.Company,
	ColumnId.TaxiService,
	ColumnId.Status,
	ColumnId.Group,
];

export const disabledColumnsIds = [];

export default columns;
